import { report as reportsApi } from '../../../api';
import { VendorDataReportList } from '../../../components/Report';

export function BuyingAgreementsReports() {
  return (
    <VendorDataReportList
      dataApi={reportsApi.getAllUnapprovedBuyingAgreement}
      exportApi={reportsApi.exportUnapprovedBuyingAgreement}
      reportType="VBA"
    />
  );
}
